import React from 'react';
import { Typography } from '@material-ui/core';

import { GQLFontAsset } from '@jewelutions/core-crm-server-api-client-domain';

import SectionCard from '../SectionCard';

import styled from 'styled-components/macro';

interface IProps {
  fontAsset: GQLFontAsset;
}

const FontTextSamples: React.FC<IProps> = ({ fontAsset }: IProps) => {
  const FontDiv = styled.div`
    @font-face {
      font-family: '${fontAsset.id}';
      src: local('GoldmanBold'), url('${fontAsset.font.media.url}') format('opentype');
      font-weight: bold;
    }
  `;

  return (
    <FontDiv>
      <SectionCard title="Font Text Samples">
        {['body2', 'body1', 'subtitle2', 'subtitle1', 'h6', 'h5', 'h4', 'h3', 'h2', 'h1'].map(
          (fontVariant: any, index: number) => {
            return (
              <Typography
                style={{ marginBottom: '20px', fontFamily: `${fontAsset.id}` }}
                variant={fontVariant}
                key={index}
              >
                Almost before we knew it, we had left the ground.
              </Typography>
            );
          }
        )}
      </SectionCard>
    </FontDiv>
  );
};

export default FontTextSamples;
